import React from 'react';
import ShortcutsSettingsSection from './settings/ShortcutsSettingsSection';
import TagsSettingsSection from './settings/TagsSettingsSection';
import BusinessHoursSettingsSection from './settings/BusinessHoursSettingsSection';
import AutomaticMessagesSettingsSection from './settings/AutomaticMessagesSettingsSection';
import GlobalMessagesSettingsSection from './settings/GlobalMessagesSettingsSection';
import useToken from 'hooks/useToken';

const SettingsView = ({ activeSubTab = 'atajos' }) => {
  const { idCatTipoUsuario } = useToken();
  const isAdmin = Number(idCatTipoUsuario) === 1;

  const effectiveSubTab = (!isAdmin && (activeSubTab === 'horarios' || activeSubTab === 'globales'))
    ? 'atajos'
    : activeSubTab;

  return (
    <div>
      {effectiveSubTab === 'atajos' && <ShortcutsSettingsSection />}
      {effectiveSubTab === 'horarios' && isAdmin && <BusinessHoursSettingsSection />}
      {effectiveSubTab === 'incidencias' && <TagsSettingsSection />}
      {effectiveSubTab === 'mensajes' && <AutomaticMessagesSettingsSection />}
      {effectiveSubTab === 'globales' && isAdmin && <GlobalMessagesSettingsSection />}
    </div>
  );
};

export default SettingsView;


